var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImmediateDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#F4823C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58844 13.2689C8.12071 13.2689 7.74315 12.8877 7.74315 12.4155C7.74315 11.9433 8.12071 11.5621 8.58844 11.5621C9.05617 11.5621 9.43373 11.9433 9.43373 12.4155C9.43373 12.8877 9.05617 13.2689 8.58844 13.2689ZM7.9122 5.41773C7.9122 5.05362 8.1996 4.76347 8.56025 4.76347C8.92091 4.76347 9.20831 5.05362 9.20831 5.41773V9.91223C9.20831 10.2763 8.92091 10.5665 8.56025 10.5665C8.1996 10.5665 7.9122 10.2763 7.9122 9.91223V5.41773ZM16.4609 13.4509L13.0854 7.52842L9.70985 1.61161C9.47881 1.20768 9.05053 0.95166 8.58844 0.95166C8.12634 0.95166 7.69807 1.20199 7.46702 1.60592L0.721624 13.4395C0.490579 13.8435 0.490579 14.3498 0.721624 14.7538C0.952669 15.1634 1.37531 15.4194 1.84304 15.4194H15.3395C15.8016 15.4194 16.2298 15.1634 16.4609 14.7595C16.6919 14.3555 16.6919 13.8549 16.4609 13.4509Z",
    fill: "#F4823C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmediateDanger);
export default __webpack_public_path__ + "static/media/ImmediateDanger.aef83de1.svg";
export { ForwardRef as ReactComponent };